import request from '@/libs/request'

// 平台用户列表
export function categoryList (data) {
  return request({
    url: `bookVideoCate/list`,
    method: 'get',
    params: data
  })
}

export function addCate (data) {
  return request({
    url: `bookVideoCate/list`,
    method: 'post',
    data
  })
}

export function cateInfo (id) {
  return request({
    url: `bookVideoCate/info/${id}`,
    method: 'get'
  })
}
export function delCate (id) {
  return request({
    url: `bookVideoCate/list/${id}`,
    method: 'delete'
  })
}

// 启用禁用用户
export function changeStatus (id) {
  return request({
    url: `bookVideoCate/changeStatus/${id}`,
    method: 'post'
  })
}
